import { forwardRef } from 'react';
import DropdownOld, { type DropdownProps } from '../Dropdown';
import { inputVariants } from './Input';
import { cn } from 'shared/src/utils';

export const Dropdown = forwardRef<HTMLSelectElement, DropdownProps>(({ className, ...props }, ref) => {
  return <DropdownOld {...props} className={cn(inputVariants(), 'py-0 border-none ring-input', className)} {...ref} />;
});
